module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle noise"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/noise')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle audio"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/audio')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle weather"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/weather')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle video"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/video')))])]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "circle adio"
  }), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$l('calendar/adio')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ed1d5ec4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/CalendarLegendPopover.vue
// module id = 480
// module chunks = 1